// TextField sizes and correspondent copy sizes
export const sizeMap = {
  'extra-small': '', // default
  'small': 'large',
  'normal': 'hotspot-title',
  'medium': 'section-subtitle',
  'medium-large': 'section-title',
  'large': 'main-subtitle',
  'extra-large': 'main-title'
};

export const autocompleteSizeMap = {
  'extra-small': 'copy', // default
  'small': 'copy',
  'normal': 'large',
  'medium': 'hotspot-title',
  'medium-large': 'section-subtitle',
  'large': 'section-title',
  'extra-large': 'main-subtitle'
};

// Icon type and correspondent action
export const actionIconsMap = {
  'view': 'togglePassword',
  'clear': 'clearInput'
};

export const PASSWORD_STRENGTH_MESSAGES = {
  length: {
    error: true,
    className: 'length',
    description: 'Minimum 8 characters'
  },
  weak: {
    error: false,
    className: 'weak',
    description: 'Weak'
  },
  fair: {
    error: false,
    className: 'fair',
    description: 'Fair'
  },
  strong: {
    error: false,
    className: 'strong',
    description: 'Strong'
  }
};



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/common.js